import React,{useState, useEffect} from 'react';
import {ApplicationContainer, ClientMediator} from "@8d-xyz/ui-react_application_f-container"
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Splash from "./components/pages/Splash";
import Plans from "./components/pages/Plans";
import About from "./components/pages/AboutUs";
import LandingO from "./components/pages/LandingO";
import LandingU from "./components/pages/LandingU";
import { useUserSession } from './lib/session/UserSession';
// import Contact from "./components/common/form/ContactDialog";
import MaintenanceDialog from './demo/platform/MaintenanceDialog';
import ToastManager from './demo/platform/ToastManager';
import sessionData from './lib/session/sessionData.json';
import {generateLazyRoutes} from './lib/util/RouteHelper.jsx';

const importPathFn = (pageName) => import(`./components/pages/${pageName}.jsx`);
const fallbackPathFn = () => import(`./components/pages/Splash.jsx`);

function NotFound() {
    return <h1>404 - Page Not Found</h1>;
}
const App = () => {
  const [maintenanceMode, setMaintenanceMode] = useState(false);
  const [initialized, setInitialized] = useState(false);
   ClientMediator.listenForEvent(`APP_S-APP-IN_MAINTENANCE`, async (data) => {
    setMaintenanceMode(true);
  });
  
  useEffect(() => {
    async function initializeApp() {
      if (window.__MAINTENANCE_MODE__) {
        //console.log('Detected pre-existing maintenance mode at boot!');
        setMaintenanceMode(true);
      }
      setInitialized(true);
    }

    initializeApp();
    return () => {
    };
  }, []);

  if (!initialized) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
        <p className="mt-4 text-gray-600 text-sm">Checking server status...</p>
      </div>
    );
  }

    return (
      <>
     

        <Router>
          {/* <nav>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </nav> */}
          
          <Routes>
            {/* <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} /> */}
            
            {/* <Route path="/splash" element={<ApplicationContainer context={<Splash />} />} />
            <Route path="/landing_o" element={ <ApplicationContainer context={<LandingO />}/>} />
            <Route path="/landing_u" element={ <ApplicationContainer context={<LandingU />}/>} /> */}
            <Route path="/about" element={<ApplicationContainer context={<About />} />} />
            <Route path="/plans" element={<ApplicationContainer context={<Plans />} />} />
            {/* <Route path="/contact" element={<ApplicationContainer context={<Contact/>} />} /> */}
            {/* <Route path="/*" element={ <ApplicationContainer context={<Home/>}/>} /> */}
           
            {generateLazyRoutes( sessionData.APP_META.RUNTIME.ROUTE_PAGES, importPathFn, fallbackPathFn)}
            {/* <Route path="/landing_o" element={ <ApplicationContainer context={<LandingO />}/>} />
            <Route path="/landing_u" element={ <ApplicationContainer context={<LandingU />}/>} />
            <Route path="/*" element={ <ApplicationContainer context={<Splash />}/>} /> */}
          </Routes>
        </Router>
      {maintenanceMode && <MaintenanceDialog />}


</>
      );
   
};

export default App;
